import { createSelector } from "reselect";
import { b64ToBlob } from "../components/Common/imageCompressor";

const nivelesReducerDataSelector = (state) => state.nivelesReducer.getIn(["data"]).toJS();

export const nivelesDataSelector = createSelector(nivelesReducerDataSelector, (dataField) => {
  return {
    niveles:
      dataField.niveles && dataField.niveles.map
        ? dataField.niveles.map((x) => ({ ...x, imagen: b64ToBlob(x.imagen) }))
        : dataField.niveles,
  };
});

export const nivelesEditSelector = createSelector(nivelesReducerDataSelector, (dataField) => {
  return {
    nivel: {
      ...dataField.nivelEdit,
      imagen: dataField.nivelEdit && b64ToBlob(dataField.nivelEdit.imagen),
      imagenOriginal: dataField.nivelEdit && b64ToBlob(dataField.nivelEdit.imagenOriginal),
    },
  };
});
